<template>
<div id="hightlight" class="row">
   <div class="col-md-12 mb-4">
        <div class="jumbotron text-white">
            <div class="row">
                <div class="col-md-8">
                    <h1>SUBSIDI BUNGA/SUBSIDI MARGIN BAGI UMKM PROGRAM PEMULIHAN EKONOMI NASIONAL (PEN)</h1>
                </div>
            </div>
            <div class="row">
                <div class="col-md-10">
                    <p>Pemerintah berkomitmen memberikan stimulus ekonomi kepada UMKM yang merupakan tulang punggung perekonomian dalam bentuk subsidi bunga/subsidi margin agar mampu bertahan dari dampak pandemi COVID-19</p>
                    <p class="m-0"><small>#UMKMTulangPunggungPerekonomian</small></p>
                    <p class="m-0"><small>#UMKMTangguh</small></p>
                </div>
            </div>
        </div>
   </div>
</div>
</template>

<script>
export default {
    name: 'Highlight',
};
</script>